import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';

interface LegalModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  type: 'termos' | 'privacidade';
}

const BrandName = () => <span className="font-display font-bold tracking-tight"><span className="text-primary">Product</span><span className="text-secondary">Docs</span></span>;

function TermosContent() {
  return (
    <div className="space-y-6 text-sm text-muted-foreground leading-relaxed">
      <section>
        <h3 className="font-display text-base font-semibold text-foreground mb-1">Introdução</h3>
        <p>Bem-vindo ao <BrandName />.</p>
        <p className="mt-1">O <BrandName /> é uma ferramenta digital destinada à estruturação de documentos e decisões de produto.</p>
      </section>
      <section>
        <h3 className="font-display text-base font-semibold text-foreground mb-1">Uso da Plataforma</h3>
        <p>A ferramenta oferece templates estruturados para apoiar organização de decisões e documentação.</p>
      </section>
      <section>
        <h3 className="font-display text-base font-semibold text-foreground mb-1">Responsabilidade sobre Conteúdo</h3>
        <p>Os documentos criados dentro da plataforma são de responsabilidade exclusiva do usuário.</p>
        <p className="mt-1">O <BrandName /> não garante sucesso de produto ou resultados de negócio.</p>
      </section>
      <section>
        <h3 className="font-display text-base font-semibold text-foreground mb-1">Disponibilidade</h3>
        <p>A plataforma pode sofrer melhorias, atualizações ou mudanças ao longo do tempo.</p>
      </section>
      <section>
        <h3 className="font-display text-base font-semibold text-foreground mb-1">Conduta do Usuário</h3>
        <p>O usuário concorda em não utilizar a plataforma para atividades ilegais ou prejudicar o funcionamento do serviço.</p>
      </section>
      <section>
        <h3 className="font-display text-base font-semibold text-foreground mb-1">Suspensão</h3>
        <p>Contas que violem os termos podem ser suspensas.</p>
      </section>
    </div>
  );
}

function PrivacidadeContent() {
  return (
    <div className="space-y-6 text-sm text-muted-foreground leading-relaxed">
      <section>
        <h3 className="font-display text-base font-semibold text-foreground mb-1">Introdução</h3>
        <p>A privacidade dos usuários é importante para o <BrandName />.</p>
      </section>
      <section>
        <h3 className="font-display text-base font-semibold text-foreground mb-1">Dados Coletados</h3>
        <ul className="list-disc list-inside space-y-1 mt-1">
          <li>Nome</li>
          <li>E-mail</li>
          <li>Documentos criados</li>
          <li>Dados necessários para funcionamento da conta</li>
        </ul>
      </section>
      <section>
        <h3 className="font-display text-base font-semibold text-foreground mb-1">Uso das Informações</h3>
        <p>Os dados são utilizados exclusivamente para funcionamento da plataforma.</p>
      </section>
      <section>
        <h3 className="font-display text-base font-semibold text-foreground mb-1">Acesso aos Dados</h3>
        <p>Os documentos pertencem ao usuário.</p>
        <p className="mt-1">O <BrandName /> pode acessar tecnicamente os dados apenas quando necessário para:</p>
        <ul className="list-disc list-inside space-y-1 mt-1">
          <li>Suporte</li>
          <li>Manutenção</li>
          <li>Melhoria do serviço</li>
        </ul>
        <p className="mt-1">O <BrandName /> não vende, compartilha ou analisa o conteúdo dos documentos dos usuários.</p>
      </section>
      <section>
        <h3 className="font-display text-base font-semibold text-foreground mb-1">Segurança</h3>
        <p>A plataforma adota práticas razoáveis de segurança.</p>
      </section>
      <section>
        <h3 className="font-display text-base font-semibold text-foreground mb-1">Direitos do Usuário</h3>
        <p>O usuário pode solicitar remoção de conta ou dados.</p>
      </section>
    </div>
  );
}

export function LegalModal({ open, onOpenChange, type }: LegalModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl max-h-[90vh] flex flex-col">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">
            {type === 'termos' ? 'Termos de Uso' : 'Política de Privacidade'}
          </DialogTitle>
        </DialogHeader>
        <ScrollArea className="flex-1 -mx-6 px-6 max-h-[75vh]">
          {type === 'termos' ? <TermosContent /> : <PrivacidadeContent />}
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
